// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CollaboratorRoleFragment = { __typename?: 'Role', id: string, displayName: string };

export type GetCollaboratorRolesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCollaboratorRolesQuery = { __typename?: 'Query', collaboratorRoles: Array<(
    { __typename?: 'Role' }
    & CollaboratorRoleFragment
  ) | null> };

export const Operations = {
  Query: {
    GetCollaboratorRoles: 'GetCollaboratorRoles' as const
  },
  Fragment: {
    CollaboratorRole: 'CollaboratorRole' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CollaboratorRoleFragmentDoc = gql`
    fragment CollaboratorRole on Role {
  id
  displayName
}
    `;
export const GetCollaboratorRolesDocument = gql`
    query GetCollaboratorRoles {
  collaboratorRoles {
    ...CollaboratorRole
  }
}
    ${CollaboratorRoleFragmentDoc}`;

/**
 * __useGetCollaboratorRolesQuery__
 *
 * To run a query within a React component, call `useGetCollaboratorRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollaboratorRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollaboratorRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollaboratorRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetCollaboratorRolesQuery, GetCollaboratorRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollaboratorRolesQuery, GetCollaboratorRolesQueryVariables>(GetCollaboratorRolesDocument, withFetchPolicyContext(options));
      }
export function useGetCollaboratorRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollaboratorRolesQuery, GetCollaboratorRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollaboratorRolesQuery, GetCollaboratorRolesQueryVariables>(GetCollaboratorRolesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetCollaboratorRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollaboratorRolesQuery, GetCollaboratorRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollaboratorRolesQuery, GetCollaboratorRolesQueryVariables>(GetCollaboratorRolesDocument, withFetchPolicyContext(options));
        }
export type GetCollaboratorRolesQueryHookResult = ReturnType<typeof useGetCollaboratorRolesQuery>;
export type GetCollaboratorRolesLazyQueryHookResult = ReturnType<typeof useGetCollaboratorRolesLazyQuery>;
export type GetCollaboratorRolesSuspenseQueryHookResult = ReturnType<typeof useGetCollaboratorRolesSuspenseQuery>;
export type GetCollaboratorRolesQueryResult = Apollo.QueryResult<GetCollaboratorRolesQuery, GetCollaboratorRolesQueryVariables>;